import { render, staticRenderFns } from "./CollectionContent.vue?vue&type=template&id=0282e6b2&scoped=true&"
import script from "./CollectionContent.vue?vue&type=script&lang=js&"
export * from "./CollectionContent.vue?vue&type=script&lang=js&"
import style0 from "./CollectionContent.vue?vue&type=style&index=0&id=0282e6b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282e6b2",
  null
  
)

export default component.exports